import { render, staticRenderFns } from "./Episode.vue?vue&type=template&id=3fbf48e4"
import script from "./Episode.vue?vue&type=script&lang=js"
export * from "./Episode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports